<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import axios from "axios";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Reset Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      token: "",
      email: "",
      password: "",
      confirmPassword: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(12)
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('password')
    },
  },
  methods: {
    resetPassword(data) {
		return new Promise((resolve, reject) => {
			axios
				.post('/reset-password', data)
				.then((response) => {
					if (response.status == 200) {
						if (response.data.status == true) {
							resolve(response);
						} else {
							reject(response);
						}
					} else {
						reject(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToReset() {
      let thisInstance = this;
      thisInstance.disableUpdateButton();
      thisInstance.submitted = true;
      // stop here if form is invalid
      thisInstance.$v.$touch();

      if (thisInstance.$v.$invalid) {
        return;
      } else {
        let data = {
          token: thisInstance.token,
          email: thisInstance.email,
          password: thisInstance.password,
          password_confirmation: thisInstance.confirmPassword,
        };
        thisInstance.resetPassword(data).then(function(response){
          if(response.data.status){
            thisInstance.tryingToReset = false;
            thisInstance.isResetError = false;
            thisInstance.isResetSuccess = true;
            thisInstance.success = response.data.message ? response.data.message : "";
            thisInstance.enableUpdateButton();
          }else{
            thisInstance.tryingToReset = false;
            thisInstance.error = response.data.message ? response.data.message : "";
            thisInstance.isResetError = true;
            thisInstance.enableUpdateButton();
          }
        },function(error){
          thisInstance.tryingToReset = false;
          thisInstance.error = error.data.message ? error.data.message : "";
          thisInstance.isResetError = true;
          thisInstance.enableUpdateButton();
        });
      }
    },
    disableUpdateButton() {
      let resetBtn = this.$refs["reset-btn"];
      let spinner = this.$refs["reset-spinner"];
      if (resetBtn && spinner) {
        resetBtn.disabled = true;
        spinner.classList.remove("d-none");
      }
    },
    enableUpdateButton() {
      let resetBtn = this.$refs["reset-btn"];
      let spinner = this.$refs["reset-spinner"];
      if (resetBtn && spinner) {
        resetBtn.disabled = false;
        spinner.classList.add("d-none");
      }
    },
  },
  mounted(){
    this.token = this.$route.params.token;
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden shadow-lg">
          <div class="card-body">
            <div class="p-2">
              <b-alert
                v-model="isResetError"
                class="mb-4"
                variant="danger"
                dismissible
                >{{ error }}</b-alert
              >
              <form @submit.prevent="tryToReset">
                <div class="mb-3">
                  <label for="useremail">Email</label>
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    id="useremail"
                    placeholder="Enter email"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                  <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                    <span v-if="!$v.email.required">Email is required.</span>
                    <span v-if="!$v.email.email">Please enter valid email.</span>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="new-password">New Password</label>
                  <input
                    type="text"
                    v-model="password"
                    class="form-control"
                    id="new-password"
                    placeholder="Enter New Password"
                    :class="{ 'is-invalid': submitted && $v.password.$error }"
                  />
                  <div v-if="submitted && $v.password.$error" class="invalid-feedback">
                    <span v-if="!$v.password.required">this field required.</span>
                    <span v-if="!$v.password.minLength">password length must be at least 12 characters long</span>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="confirm-password">Confirm Password</label>
                  <input
                    type="text"
                    v-model="confirmPassword"
                    class="form-control"
                    id="confirm-password"
                    placeholder="Confirm Password"
                    :class="{ 'is-invalid': submitted && $v.confirmPassword.$error }"
                  />
                  <div v-if="submitted && $v.confirmPassword.$error" class="invalid-feedback">
                    <span v-if="!$v.confirmPassword.required">this field required.</span>
                    <span v-if="!$v.confirmPassword.sameAsPassword">password does not match.</span>
                  </div>
                </div>
                <div class="mb-3 row mb-0">
                  <div class="col-12 text-end">
                    <button class="btn btn-primary w-md" type="submit" ref="reset-btn">
                      <span>Reset</span>
                      <div
                        class="ms-2 spinner-border spinner-border-sm d-none"
                        role="status"
                        ref="reset-spinner"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div class="mt-3 text-center">
              <b-link :to="{name: 'login'}">Login</b-link>
            </div>

          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
